import React from 'react';
import PropTypes from 'prop-types';

import './HamburgerNav.scss';

/**
 * Navigation button that shows in the header on smaller devices
 */

const HamburgerNavComponent = (props) => (
  <a
    className="hamburgernav-component"
    href="#"
    onClick={(e) => {
      e.preventDefault();
      if (props.active === false) {
        props.actions.openHamburgerNav();
      } else {
        props.actions.closeHamburgerNav();
      }
    }}
  >
    <span className={`hamburgernav-component__icon ${props.active ? 'hamburgernav-component__icon--open' : ''}`}>
      <span />
      <span />
      <span />
      <span />
    </span>
  </a>
);

HamburgerNavComponent.displayName = 'HamburgerNav';

HamburgerNavComponent.propTypes = {
  active: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    openHamburgerNav: PropTypes.func.isRequired,
    closeHamburgerNav: PropTypes.func.isRequired,
  }).isRequired,
};

export default HamburgerNavComponent;
